import { Box, Wrap, WrapItem, Button, Text } from '@chakra-ui/react'
import { useIsUnionTier } from '../../hooks/useIsUnionTier'

interface SectorFilterProps {
  options: string[]
  value: string[]
  onChange: (next: string[]) => void
  label?: string
}

/** Multi-select employer-sector picker (L16). Toggle-chips fed by distinct Worksite.Type
 *  values from /contacts/search/options. Hidden entirely when the committee has no sectors.
 *  value/onChange plug into both useState and a react-hook-form Controller. */
export function SectorFilter({ options, value, onChange, label = 'Employer sector' }: SectorFilterProps) {
  if (!useIsUnionTier()) return null
  if (options.length === 0) return null

  const toggle = (sector: string) =>
    onChange(value.includes(sector) ? value.filter((s) => s !== sector) : [...value, sector])

  return (
    <Box>
      <Text fontSize="sm" color="ink.2" mb={1}>{label}</Text>
      <Wrap gap={2}>
        {options.map((sector) => {
          const selected = value.includes(sector)
          return (
            <WrapItem key={sector}>
              <Button
                type="button"
                size="sm"
                minH="44px"
                borderRadius="full"
                variant={selected ? 'solid' : 'outline'}
                colorPalette={selected ? 'blue' : 'gray'}
                aria-pressed={selected}
                onClick={() => toggle(sector)}
              >
                {sector}
              </Button>
            </WrapItem>
          )
        })}
      </Wrap>
    </Box>
  )
}
